module.exports = __webpack_public_path__ + "static/media/012.f43ab4f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/normals/012.jpg
// module id = 485
// module chunks = 0